import React from 'react';

import classNames from 'classnames';

import classes from './SidebarGroup.module.scss';
import { SidebarNavLink } from '../../../components/SidebarNavLink/SidebarNavLink';
import { SidebarCollapseMenu } from '../../../components/SidebarCollapseMenu/SidebarCollapseMenu';
import { SIDEBAR_ITEM_TYPE } from '../../../../../constants/system/headerSettings';
import { GroupItem } from '../../../../../interfaces/system/SidebarNavConfig';
import { useSidebarContext } from '../../../hooks/SidebarContext';
import { SidebarMenu } from '../../../components/SidebarMenu/SidebarMenu';

type SidebarGroupProps = {
  group: GroupItem;
};

const SidebarGroup = ({ group }: SidebarGroupProps) => {
  const { isCollapsed } = useSidebarContext();

  const labelClassNames = classNames(classes.label, {
    [classes.collapsed]: isCollapsed,
  });

  return (
    <div className={classes.group}>
      {group.label && (
        <div className={labelClassNames}>{isCollapsed ? '·' : group.label}</div>
      )}
      {group.items.map((item) => {
        switch (item.type) {
          case SIDEBAR_ITEM_TYPE.LINK:
            return <SidebarNavLink item={item} key={item.path} />;
          case SIDEBAR_ITEM_TYPE.COLLAPSE_MENU:
            return isCollapsed ? (
              <SidebarMenu item={item} key={item.label} />
            ) : (
              <SidebarCollapseMenu item={item} key={item.label} />
            );
          default:
            return null;
        }
      })}
    </div>
  );
};

export { SidebarGroup };
